import React, { useState } from 'react';
import { Dialog, IconButton, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { Button } from 'devextreme-react/button';
import { Close } from '@material-ui/icons';
import { CheckBox, NumberBox, SelectBox, TagBox, TextArea } from 'devextreme-react';
import { TextBox } from 'devextreme-react/text-box';
import { formatToCurrency } from '../../../commonFunctions/FormatterFunctions';

function InputWrapper(props) {
  const { classes, label } = props;
  return (
    <div className="input-admin">
      <label className={classes?.label}>{label}</label>
      <div style={{ width: '75%' }} className="dx-field-value">
        {props.children}
      </div>
    </div>
  );
}

function BrandModelDialog(props) {
  const { handleDelete, editMode, operation, title, open, onClose, handleOnClick, dialogSize, dataForm, onChange } = props;
  const [phoneMask, setPhoneMask] = useState('+00 (00) 0000-0000');

  const dialogStyles = {
    // width: operation !== 'delete' ? (dialogSize?.width || '550px') : '550px',
    // height: operation !== 'delete' ? (dialogSize?.height || '180px') : '180px',
    width: '550px',
    height: '100%',
    minWidth: 'max-content',
  };

  const buttonStyles = {
    padding: '6px 16px',
    fontSize: '13px',
    margin: 'auto',
    marginTop: '5px',
    borderRadius: '0',
    color: 'white',
    backgroundColor: '#3B5158',
  };

  const buttonSaveStyles = {
    padding: '6px 16px',
    fontSize: '13px',
    marginRight: '16px',
    marginTop: '5px',
    float: 'right',
    borderRadius: '0',
    color: 'white',
    backgroundColor: '#3B5158',
  };

  const closeButton = {
    position: 'absolute',
    right: '6px',
    top: '0px',
  };

  return (
    <Dialog maxWidth={'xl'} open={open} onClose={onClose}>
      <div style={dialogStyles}>
        <DialogTitle disableTypography className="titleStyles" style={{ color: 'white', minHeight: '20px', backgroundColor: '#3B5158', marginBottom: '15px', paddingBlock: '12px' }}>
          {title}
          {/* {operation !== 'delete' && <IconButton onClick = {onClose} style = {closeButton}> <Close style={{color: "white"}}/> </IconButton>} */}
          <IconButton onClick={onClose} style={closeButton}>
            {' '}
            <Close style={{ color: 'white' }} />{' '}
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <InputWrapper classes={props.classes} label={'Modelo'}>
            <TextBox key={'Modelo'} disabled name="Modelo" value={dataForm?.modelName} height={25}></TextBox>
          </InputWrapper>

          <InputWrapper classes={props.classes} label={'Preço'}>
            <TextBox key={'Preço'} disabled name="reço" value={formatToCurrency(dataForm?.price)} height={25}></TextBox>
          </InputWrapper>

          <InputWrapper classes={props.classes} label={'Quantidade'}>
            <NumberBox
              value={dataForm?.quantity}
              showSpinButtons={true}
              showClearButton={true}
              min={1}
              max={100}
              onValueChanged={(e) => onChange('quantity', e.value)} 
              height={25}
            />
          </InputWrapper>

          <InputWrapper classes={props.classes} label={'Descons. rebate (%)'}>
            <NumberBox
              value={dataForm?.disregardRebatePercent || 0}
              showSpinButtons={true}
              showClearButton={true}
              format="0.##'%'"
              min={0.0}
              onValueChanged={(e) => onChange('disregardRebatePercent', e.value)}
              height={25}
            />

          </InputWrapper>

          <InputWrapper classes={props.classes} label={'Observações'}>
            <TextBox
              key={'observations'}
              name="observations"
              value={dataForm?.observations}
              placeholder="ex: Cor e local de entraga"
              onValueChanged={(e) => onChange('observations', e.value)}
              height={25}
            ></TextBox>
          </InputWrapper>
        </DialogContent>
        <DialogActions>
          <>
            <Button onClick={(e) => handleDelete(dataForm?.quotationBrandModelId)} style={buttonStyles}>
              Excluir
            </Button>
            <Button onClick={handleOnClick} style={buttonSaveStyles}>
              Editar
            </Button>
          </>
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default BrandModelDialog;
